import React from "react";

const mapUrl = "https://maps.app.goo.gl/YZPuv7T5pLMiMoqaA";
const embedUrl =
  "https://www.google.com/maps?q=Cyber%20Meadows%20Kondapur%20Hyderabad&output=embed";

export default function LocationCyber() {
  return (
    <section className="cyber-location-section" id="woods-location">
      <div className="cyber-location-map">
        <iframe
          title="Vessella Cyber Meadows location"
          src={embedUrl}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>

      <div className="cyber-location-card">
        <span className="cyber-location-eyebrow">Location</span>
        <h2>Cyber Meadows</h2>
        <p>
          Set in Kondapur with quick access to Hyderabad&apos;s IT corridor,
          everyday conveniences, and key city routes.
        </p>
        <a href={mapUrl} target="_blank" rel="noopener noreferrer">
          View on Google Maps
        </a>
      </div>
    </section>
  );
}
